import { Alert, AlertDescription, AlertTitle } from '@devizy/ui';
import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { PageHeader } from '@/components/dashboard/page-header';
import { BidderDecisionClient } from '@/components/selection/bidder-decision-client';
import { trpc } from '@/lib/trpc/client';

export const Route = createFileRoute('/_app/bids/$bidId/decision')({
  component: BidderDecisionPage,
});

function BidderDecisionPage(): React.ReactElement {
  const { bidId } = Route.useParams();
  const t = useTranslations('selection.bidderDecision');
  const { data, isLoading, isError } = trpc.selection.byBidIdLatest.useQuery({ bidId });

  if (isLoading) {
    return (
      <div className="flex flex-col gap-6">
        <PageHeader title={t('title')} subtitle={t('subtitle')} />
        <p className="text-muted-foreground text-sm">{t('loading')}</p>
      </div>
    );
  }

  if (isError || !data?.selectionId) {
    return (
      <div className="flex flex-col gap-6">
        <PageHeader title={t('title')} subtitle={t('subtitle')} />
        <Alert variant="error">
          <AlertTitle>{t('notFoundTitle')}</AlertTitle>
          <AlertDescription>{t('notFoundBody')}</AlertDescription>
        </Alert>
      </div>
    );
  }

  return <BidderDecisionClient selectionId={data.selectionId} bidId={bidId} />;
}
